import { render, staticRenderFns } from "./Switches.vue?vue&type=template&id=60dea916"
import script from "./Switches.vue?vue&type=script&lang=ts"
export * from "./Switches.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports